export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-574.438631ee.jpg";